import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GenerateCouponReport,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { Coupon } from "../../../graphql/models";
import { CouponEditForm } from "./coupons_form";

import useCouponsStyle from "./coupons.style";
import { useLoggedUserInfo } from "../../../hooks";

function CouponsPage(props: any) {
  const classes = useCouponsStyle();

  const tableRef = useRef();

  //const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formCoupon, setFormCoupon] = useState<Coupon | undefined>(void 0);

  const { isAdminUser } = useLoggedUserInfo();

  const addNewCoupon = () => {
    setFormCoupon({} as Coupon);
    setFormDialogOpened(true);
  };

  const editCoupon = (row) => {
    setFormCoupon({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormCoupon(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const onValueDeleted = () => {
    setFormCoupon(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback(
    (row: Coupon) => {
      const actions: ReactNode[] = [];

      if (isAdminUser) {
        actions.push(<EditButton onClick={() => editCoupon(row)} />);
        actions.push(
          <GenerateCouponReport coupon={row} buttonLabel={"SCARICA REPORT"} />
        );
      }

      return actions;
    },
    [isAdminUser]
  );

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];

    if (isAdminUser) {
      actions.push(
        <Button
          key="addNewCoupon"
          variant="contained"
          color="primary"
          onClick={() => addNewCoupon()}
        >
          Aggiungi Nuovo
        </Button>
      );
    }

    return actions;
  }, [isAdminUser]);

  // const { isAdminUser } = useLoggedUserInfo();

  const tableActions = useMemo(() => {
    const columns = [
      "",
      "Data creazione",
      "Servizio",
      "Tipologia",
      "Codice Coupon",
      "Max utilizzi",
      "Data Scadenza",
    ];

    return columns;
  }, []);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar title={"Coupons"} actions={actionToolbarActions} />
        <GqlTable
          ref={tableRef}
          columns={[...tableActions].map((v) => (
            <TableCell>{v}</TableCell>
          ))}
          query={QUERIES.BACKOFFICE_COUPONS}
          queryResultDataField="coupons"
          rows={(row: Coupon) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{new Date(row.createdAt).toLocaleString()}</TableCell>
              <TableCell>{row.service?.name}</TableCell>
              <TableCell>{row.type}</TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{row.maxUseCount}</TableCell>
              <TableCell>
                {row.expireDate
                  ? new Date(row.expireDate).toLocaleString()
                  : ""}
              </TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica contatto"}
        >
          <CouponEditForm
            value={formCoupon}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
            onValueDeleted={onValueDeleted}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(CouponsPage);
